<template>
  <div>

    <v-snackbar
        absolute
        v-model="snackbar.active"
        :color="snackbar.color"
        :top="true"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.active = false">
        Fechar
      </v-btn>
    </v-snackbar>

    <CabecalhoCadastro
        descricao="Usuários"
        icone="mdi-account"
        :pesquisar="pesquisar"
        :botoes="botoesCabecalho"
    />

    <v-data-table
        class="elevation-1"
        :loading="propriedadesTabela.carregando"
        :headers="propriedadesTabela.headers"
        :items="propriedadesTabela.items"
        :items-per-page="options.itemsPerPage"
        :footer-props="propriedadesTabela.footerProps"
        :noResultsText="propriedadesTabela.noResultText"
        :noDataText="propriedadesTabela.noDataText"
        :server-items-length="propriedadesTabela.total"
        :page.sync="propriedadesTabela.paginaAtual"
        :options.sync="options"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon small color="blue" @click="trocarSenha(item)">mdi-key</v-icon>
            </v-btn>
          </template>
          <span>Trocar Senha</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <TrocarSenha
        :mostrar="mostrarTrocarSenha"
        :usuario="usuarioSelecionado"
        :fechar="fecharTrocarSenha"
        :sucesso="sucessoTrocarSenha"
    >

    </TrocarSenha>
  </div>
</template>

<script>
import CabecalhoCadastro from "@/components/CabecalhoCadastro.vue";
import UserService from "@/service/UserService";
import _ from "lodash";
import TrocarSenha from "@/views/Master/Usuarios/TrocarSenha.vue";

export default {
  components: {TrocarSenha, CabecalhoCadastro},
  data() {
    return {
      snackbar: {
        message: "",
        color: "",
        active: ""
      },
      usuarioSelecionado: {},
      mostrarTrocarSenha: false,
      botoesCabecalho: [
        {funcao: this.cadastrar, icone: 'add', tooltip: 'Cadastro', cor: 'blue'}
      ],
      propriedadesTabela: {
        paginaAtual: 1,
        pesquisa: "",
        carregando: false,
        total: 0,
        items: [],
        itensPorPagina: 5,
        noResultText: "Nenhuma cidade encontrada.",
        noDataText: "Nenhuma cidade cadastrada.",
        footerProps: {
          itemsPerPageText: "Itens por página:",
          itemsPerPageOptions: [5, 10, 20, 50]
        },
        headers: [
          {
            text: "Código",
            value: "id",
            sortable: false,

          },
          {
            text: "Nome",
            value: "nome",
            sortable: false,
          },
          {
            text: "Login",
            value: "login",
            sortable: false,
          },
          {
            text: "E-mail",
            value: "email",
            sortable: false,
          },
          {
            text: "Perfil",
            value: "nomeDoPerfil",
            sortable: false,
          },
          {
            text: "Ações",
            value: "action",
            align: "center",
            sortable: false,
            width: "220px"
          }
        ]
      },
      options: {
        itemsPerPage: 5,
        page: 1,
        sortBy: [],
        sortDesc: []
      },
    }
  },
  methods: {

    pesquisar(pesquisa) {
      this.options.page = 1;
      this.propriedadesTabela.paginaAtual = 1;
      this.propriedadesTabela.pesquisa = pesquisa;
      this.buscarUsuarios()
    },

    cadastrar() {

    },

    trocarSenha(item) {
      this.usuarioSelecionado = item;
      this.mostrarTrocarSenha = true;
    },

    fecharTrocarSenha() {
      this.mostrarTrocarSenha = false;
    },

    sucessoTrocarSenha() {
      this.snackbar.color = "green";
      this.snackbar.message = "Senha alterada com sucesso!";
      this.snackbar.active = true;
      this.fecharTrocarSenha()
    },

    async buscarUsuarios() {
      this.propriedadesTabela.carregando = true;
      const response = await UserService.buscarUsuarios(this.options.itemsPerPage, this.options.page - 1, this.propriedadesTabela.pesquisa);
      const data = response.data;
      console.log(data)
      this.propriedadesTabela.items = data.content;
      this.propriedadesTabela.total = data.totalElements;
      this.propriedadesTabela.carregando = false;
    }

  },
  watch: {
    options: _.debounce(function () {
      this.buscarUsuarios();
    }, 250)
  },
  created() {
    this.buscarUsuarios();
  }
}
</script>